(function(){
var root = document.querySelector('.moa');
if(!root) return;
var form = document.getElementById('moa-sub-form');
var variantInput = document.getElementById('moa-variant');
var planInput = document.getElementById('moa-plan');
var pecasProp = document.getElementById('moa-pecas-prop');
function syncPlan(){
var sel = form.querySelector('input[name="moa-plano"]:checked');
if(sel){ variantInput.value = sel.getAttribute('data-variant') || ''; planInput.value = sel.getAttribute('data-plan') || ''; }
}
if(form){
form.querySelectorAll('input[name="moa-plano"]').forEach(function(r){ r.addEventListener('change', syncPlan); });
syncPlan();
root.querySelectorAll('[data-pick]').forEach(function(a){
a.addEventListener('click', function(){
var want = a.getAttribute('data-pick');
var radio = form.querySelector('input[name="moa-plano"][value="'+want+'"]');
if(radio){ radio.checked = true; syncPlan(); }
});
});
form.addEventListener('submit', function(e){
e.preventDefault();
var tiposErr = document.getElementById('moa-tipos-err');
var formErr = document.getElementById('moa-form-err');
if(formErr) formErr.style.display='none';
var tipos = form.querySelectorAll('.moa-tipo:checked');
if(tipos.length === 0){
if(tiposErr) tiposErr.style.display = 'block';
document.getElementById('moa-tipos').scrollIntoView({behavior:'smooth',block:'center'});
return;
}
if(tiposErr) tiposErr.style.display='none';
var arr = []; tipos.forEach(function(c){ arr.push(c.value); });
if(pecasProp) pecasProp.value = arr.join(', ');
syncPlan();
if(!variantInput.value){ if(formErr){ formErr.textContent='Selecione um plano.'; formErr.style.display='block'; } return; }
var btn = form.querySelector('.moa-submit');
if(btn){ btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'A processar…'; }
var fd = new FormData(form);
fd.delete('moa-plano');
if(!planInput.value){ fd.delete('selling_plan'); }
fetch('/cart/add.js', { method:'POST', headers:{'Accept':'application/json'}, body: fd })
.then(function(r){ if(!r.ok){ return r.json().then(function(j){ throw new Error((j && j.description) || 'Erro ao adicionar ao carrinho'); }); } return r.json(); })
.then(function(){ window.location.href = '/checkout'; })
.catch(function(err){
if(btn){ btn.disabled = false; btn.textContent = btn.dataset.label || 'Quero subscrever'; }
if(formErr){ formErr.textContent = 'Não foi possível avançar: ' + err.message; formErr.style.display='block'; }
});
});
}
var items = root.querySelectorAll('.reveal');
if('IntersectionObserver' in window){
var io = new IntersectionObserver(function(entries){
entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
},{threshold:.14});
items.forEach(function(el){ io.observe(el); });
} else {
items.forEach(function(el){ el.classList.add('in'); });
}
})();
